import AgendaViewBase from '../AgendaViewBase/AgendaViewBase';
import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import GenericDialog from '../../moreCore/UI/GenericDialog/GenericDialog';
import "../../moreCore/UI/GenericDialog/GenericDialog";
import _TabEnabledMixin from '../../moreCore/UI/Tabbing/_TabEnabledMixin';
import { EvBookingView } from "../_loadingHelpers/VAMv2";
import { VAM2types } from "../_loadingHelpers/VAMv2Types";
import { HtmlHelpers, StringHelpers, TranslationHelpers, WindowHelpers } from "../../more/Helpers";
import { OE_CheckinTypes } from "./OE_Types";
import Edit from "../../moreCore/UI/Edit/Edit";



interface procedureItems {
    input: MdsLax<InstanceType<typeof Edit>>, dlg: MdsLax<InstanceType<typeof GenericDialog>>, container: HTMLElement, entity: OE_CheckinTypes.EvBookingWithOrchestraEmployments, view: MdsLax<InstanceType<typeof EvBookingView>>
}
class OE_CheckinTerminalAgenda extends compose(AgendaViewBase<any>, _TabEnabledMixin) {
    //templateString = template; // Standard verwenden...



    _onEmbedding(pageConfig: Tabbing.TabContainerPage, containerName: string) {

    }

    private _tableFormatter(cell: StaticTable.StaticTableCell<OE_CheckinTypes.EvBookingWithOrchestraEmployments>, rowgroup: StaticTable.StaticTableRowGroup<OE_CheckinTypes.EvBookingWithOrchestraEmployments>) {
        let entity = cell.entity;
        let name = cell.name;

        switch (cell.name) {

        }

        return false;
    }


    private _onClick_Row(row: StaticTable.StaticTableRow<OE_CheckinTypes.EvBookingWithOrchestraEmployments>, rowGroup: StaticTable.StaticTableRowGroup<OE_CheckinTypes.EvBookingWithOrchestraEmployments>) {

        let entity = rowGroup.entity;

        this.openForm(entity);

    }

    openForm(entity: OE_CheckinTypes.EvBookingWithOrchestraEmployments) {
        if (!entity) return;

        let view = new EvBookingView();
        view.useDefaultButtons = false;
        view.setup(entity.ID, entity.gDisp_1, null, "employmentCheckin");

        view.showAsDlg();

        view.addButton("openOTP", "OECheckinTerminal__Label_OpenOTP", lang.hitch(this, this._onClick_OpenOTP, entity, view), null, null, "fas fa-key", false, "first");


        
    }

    private _onClick_OpenOTP(entity: OE_CheckinTypes.EvBookingWithOrchestraEmployments, view: MdsLax<InstanceType<typeof EvBookingView>>) {
        let container = this.UiModder.domConstruct.create("form", {
            "autocomplete": "off"
        });


        let input = new Edit();
        input.setInputName(StringHelpers.randomID(8));
        input.setInputType("password");
        input.setMandatory(true);
        input.setLabel("OECheckinTerminal__Label_InputPassword");
        input.placeAt(container);

        let dlg = new GenericDialog();

        let data: procedureItems = {
            dlg: dlg,
            container: container,
            entity: entity,
            input: input,
            view: view
        }

        dlg.setup({
            content: container,
            buttonPreset: "okcancel",
            closeOnEnter: false,
            header: "OECheckinTerminal__Label_InputPassword",
            callback: lang.hitch(this, this._onEnterPassword, data),
            keepOpen: true
        });

        dlg._setSubTitleAttr("OECheckinTerminal__Message_InputPassword");

        dlg.disableButton("ok");

        input.on("change", lang.hitch(this, this._onChangePwInput, dlg, input));
        
        input.on("enterKey", lang.hitch(this, this._onEnterPassword, data, 1));
    }

    private _onChangePwInput(dlg: MdsLax<InstanceType<typeof GenericDialog>>, input: MdsLax<InstanceType<typeof Edit>>) {
        dlg.enableButton("ok", !!input.getValue());
    }

    private _onEnterPassword(data: procedureItems, result: number) {
       
        if (result <= 0) {
            data.dlg.close(-1, true);
            return;
        }

        data.dlg.disableAllButtons(true);
        this.hourGlassStart(data.container);

        let value = data.input.getValue();
        let hash = StringHelpers.hashMD5(value);

        let requestdata = {
            "passwordHash": hash,
            "evBookingID": data.entity.ID
        }

        this.RequestManager.post(
            window.appRoot + "OrchestraEmployment/EnterOtpTerminal",
            {
                jsonData: JSON.stringify(requestdata)
            },
            lang.hitch(this, this._onTerminalResponse, data),
            lang.hitch(this, this._onTerminalError, data)
        );

    //    this.RequestManager.callfunction(
    //        "Webtool_API_OECheckinTerminal__CheckCredentials",
    //        requestdata,
    //        lang.hitch(this, this._onCredentialsCheckResponse, data),
    //        lang.hitch(this, this._onCredentialsCheckError, data)
    //    );
    }

    private _onTerminalResponse(data: procedureItems, response: string) {

        // PW IST OK,
        // response ist der erhaltene Link

        data.dlg.disableAllButtons(false);
        this.hourGlassEnd(data.container);

        data.dlg.close(-1, true);

        this.showToast("OECheckinTerminal__Forwarding");

        location.href = window.appRoot + "OrchestraEmployment/CheckinOTP?guid=" + response + "&evb=" + data.entity.ID;
        
    }
    private _onTerminalError(data: procedureItems, error: more.requestErrorMessage) {
        data.dlg.disableAllButtons(false);
        this.hourGlassEnd(data.container);

        this.showToast({
            title: "error",
            message: error.Message
        }, toasterIcons.error);
    }



    protected onReloadData() {
    }


    //-----------------------own methods -------------------------end
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this.RequestManager.handleAs = "jsonWithDate";

        this.setupAgendaViewWithCallfunction(
            "Webtool_API_OECheckinTerminal__GetAgendaFilterOptions",
            "Webtool_API_OECheckinTerminal__GetEvBookingAgenda",
            lang.hitch(this, this._onClick_Row),
            this._tableFormatter,
            null
        );

        WindowHelpers.setTitles("OECheckinTerminal__MainTitle");
    }
    startup(): void {
        super.startup.apply(this, arguments as any);

    }
}

export default mdsWidget(OE_CheckinTerminalAgenda);